import React, { ReactElement, useState } from 'react';
import { SearchResults, SingleSelect } from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../../types/SafeParameterSetter';
import { SubjectItem } from '../../../../model/legislativnyMaterial/SubjectItem';
import LegMaterialListFilter from '../../../../model/legislativnyMaterial/LegMaterialListFilter';
import useSearchZodpovednyPredkladatel from '../hooks/useSearchZodpovednyPredkladatel';
import { MAX_MULTISELECT_RESULT, SHOW_ALL_MAX_RESULT } from '../../../../constants/MultiSelectConstant';

interface Props {
  filterCopy: LegMaterialListFilter;
  filter: LegMaterialListFilter;
  onUpdateField: SafeParameterSetter<LegMaterialListFilter>;
  onUpdateFieldCopy: SafeParameterSetter<LegMaterialListFilter>;
  isExpanded?: boolean;
}

const PredkladatelSingleSelect = ({
  filterCopy,
  filter,
  onUpdateField,
  onUpdateFieldCopy,
  isExpanded = !!filter.predkladatel,
}: Props): ReactElement => {
  const [searchText, setSearchText] = useState('');
  const [showList, setShowList] = useState<boolean>(false);
  const [limit, setLimit] = useState<number>(MAX_MULTISELECT_RESULT);
  const [execute, setExecute] = useState(!!filter.predkladatel);

  const {
    pouzivatelia,
    pouzivateliaStatus,
  } = useSearchZodpovednyPredkladatel(filterCopy?.predkladatel?.nazov || searchText, limit, execute);

  const handleSelectedItemChange = (item: SubjectItem): void => {
    setShowList(false);
    if (item) {
      onUpdateField('predkladatel', item);
    } else {
      onUpdateFieldCopy('predkladatel', item);
    }
  };

  return (
    <ExpansionPanel
      title="Zodpovedný predkladateľ"
      isExpanded={isExpanded}
      onExpand={() => setExecute(true)}
    >
      <div className="single-select-input-wrapper">
        <SingleSelect
          id="zodpovednyPredkladatelSingleSelect"
          name="zodpovednyPredkladatelSingleSelect"
          searchText={searchText}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          selectedItem={filterCopy.predkladatel || null}
          setSelectedItem={handleSelectedItemChange}
          selectedItemValue={filter.predkladatel?.nazov || ''}
          visibilityMinSearchLength={0}
          showList={showList}
          setShowList={setShowList}
          aria-label="Zodpovedný predkladateľ"
        />
        <SearchResults
          loadingShowAll={pouzivateliaStatus.loading}
          className="single-select-fazet"
          handleShowAll={() => {
            setLimit(SHOW_ALL_MAX_RESULT);
          }}
          withShowAllButton={(limit === MAX_MULTISELECT_RESULT
            && pouzivatelia.length === MAX_MULTISELECT_RESULT)
          || (limit === SHOW_ALL_MAX_RESULT && pouzivatelia.length <= MAX_MULTISELECT_RESULT)}
          setSearchText={(text) => {
            setSearchText(text);
            setLimit(MAX_MULTISELECT_RESULT);
          }}
          data={pouzivatelia}
          setSelectedItem={handleSelectedItemChange}
          dataAttributesToShow={[{ key: 'nazov', label: '' }]}
          type="column"
          size="m"
          visible={searchText.trim().length > 0 || showList}
        />
      </div>
    </ExpansionPanel>
  );
};

export default PredkladatelSingleSelect;
